import WorkInProgress from "../../../work-in-progress/WorkInProgress";
import "./styles.css";

export default function MyWalletsPage() {
    return (
        <div className="wallet-page-container">
            <WorkInProgress />
        </div>
    )
}